import ConfigGeneral from '../config/general';

/* eslint-disable import/no-anonymous-default-export */
export default {
	components: {
		map: {
			mapLayer: 'Kartenebene',
		},
		mapFilter: {
			searchPrimary: 'Suche',
			searchSecondary: 'Name der Siedlung oder des Ortes',
			searchPlaceholder: 'Geben Sie den gesuchten Begriff hier ein',
			filterPrimary: 'Standorttyp',
			filterSecondary: 'Filtern nach Kategorien',
			dataPrimary: 'Verfügbare Daten',
			dataSecondary: 'Filtern nach verfügbaren Informationen',
		},
		mapLegend: {
			title: 'Legende',
			seaLevel: 'Meereshöhe',
			belowSeaLevel: 'Unter dem Meeresspiegel',
			elevation100: '100 m Höhenanstieg',
			elevation50: '50 m Höhenanstieg',
			broadLeavedForest: 'Laubwald',
			coniferousForest: 'Nadelwald',
			mixedForest: 'Mischwald',
			naturalGrasslands: 'Grasland',
			moorsAndHeathland: 'Heideland',
			sclerophyllousVegetation: 'Hartlaubvegetation',
			transitionalWoodlandShrub: 'Gebüsch-Waldrand',
			beachesDunesSands: 'Sand',
			inlandMarshes: 'Sumpf',
			peatBogs: 'Torfmoor',
			saltMarshes: 'Salzmoor',
			intertidalFlats: 'Gezeitenzone',
			motorway: 'Autobahn',
			mainRoad: 'Hauptstraße',
			railway: 'Eisenbahn',
			administrativeBoundary: 'Verwaltungsgrenze',
			lakeAndWaterTank: 'See und Stausee',
			forest: 'Wald',
			natureReserve: 'Naturschutzgebiet',
			grasslandAndMeadow: 'Grasland und Wiese',
			pedestrianZone: 'Fußgängerzone',
			commericalArea: 'Gewerbegebiet',
			industrialArea: 'Industriegebiet',
		},
		placePopup: {
			imagesAvailable: 'Bild verfügbar',
			videosAvailable: 'Video verfügbar',
			details: 'Details',
		},
		placeDetails: {
			overview: 'Übersicht',
			guide: 'Einführung',
			reconstruction: 'Rekonstruktion',
			media: 'Medien',
			placeType: 'Standorttyp',
			altNames: 'Andere Namen',
			location: 'Siedlung',
			coordinates: 'Koordinaten',
			openInNewWindow: 'In neuem Fenster öffnen',
		},
	},
	app: {
		loadingError: 'Fehler beim Laden der Daten',
		impressum: 'Impressum',
		close: 'schließen',
	},
	global: {
		yes: 'Ja',
		no: 'Nein',
		photo: 'Bilder',
		video: 'Video',
		guide: 'Beschreibung',
	},
	fancybox: {
		AJAX_FORBIDDEN: "Fehler beim Laden",
		AJAX_NOT_FOUND: "Fehler beim Laden",
		CLOSE: "Schließen",
		DOWNLOAD: "Download",
		ELEMENT_NOT_FOUND: "Fehler beim Laden",
		ERROR: "Fehler beim Laden",
		IFRAME_ERROR: "Fehler beim Laden",
		IMAGE_ERROR: "Fehler beim Laden",
		MODAL: "Das Fenster kann mit der ESC-Taste geschlossen werden",
		NEXT: "Weiter",
		PREV: "Zurück",
		TOGGLE_FULLSCREEN: "Vollbild",
		TOGGLE_SLIDESHOW: "Diashow",
		TOGGLE_THUMBS: "Miniaturen",
		TOGGLE_ZOOM: "Zoom",
	},
	filters: {
		state: {
			label: 'Status',
			all: 'Alle',
			active: 'Aktiv',
			inactive: 'Inaktiv',
		},
	},
	resources: {
		placetypes: {
			name: 'Standorttypen',
			fields: {
				id: '#',
				name: 'Name',
				name_display: 'Name',
				state: 'Aktiv',
				ordering: 'Bestellung',
				icon: 'Ikon (SVG)'
			}
		},
		phototypes: {
			name: 'Bildtypen',
			fields: {
				id: '#',
				name: 'Name',
				name_display: 'Name',
				state: 'Aktiv',
				ordering: 'Bestellung',
			}
		},
		modeltypes: {
			name: '3D-Modelltypen',
			fields: {
				id: '#',
				name: 'Name',
				name_display: 'Name',
				state: 'Aktiv',
				ordering: 'Bestellung',
			}
		},
		users: {
			name: 'Nutzer',
			fields: {
				id: '#',
				name: 'Name',
				email: 'E-Mail-Adresse',
				password: 'Passwort',
			}
		},
		places: {
			name: 'Siedlung',
			fields: {
				id: '#',
				name: 'Name',
				name_display: 'Name',
				alt_name: 'Alternativer Name',
				location: 'Ort',
				location_display: 'Ort',
				guide_intro: 'Kurzbeschreibung',
				guide: 'Einführung',
				place_type_ids: 'Typ',
				coordinate_x: 'Längengrad',
				coordinate_y: 'Breitengrad',
				state: 'Aktiv',
				ordering: 'Reihenfolge',
				source: 'Anbieter',
				video_id: 'Video-ID',
				caption: 'Titel',
				reconstruction: 'Rekonstruktion',
				model_type_id: 'Typ',
				preview: 'Vorschaubilddatei',
				model: 'Modelldatei',
				models: '',
				videos: '',
				previewInput: 'Vorschaubilddatei hierher ziehen oder zum Auswählen klicken',
				modelInput: 'Modelldatei hierher ziehen oder zum Auswählen klicken',
			},
			tab: {
				summary: 'Allgemein',
				photos: 'Fotos',
				videos: 'Videos',
				models: '3D-Modelle',
			},
		},
		settings: {
			name: 'Einstellungen',
			fields: {
				page_title: 'Kopfzeilentext',
				sidebar_title: 'Seitenleistentitel',
				sidebar_text: 'Einführungstext der Seitenleiste',
				footer_text: 'Fußzeilentext',
				impressum: 'Impressumsinhalt',
			}
		},
	},
	ra: {
		action: {
			add_filter: 'Filter',
			add: 'Hinzufügen',
			back: 'Zurück',
			bulk_actions: '%{smart_count} kiválasztva',
			cancel: 'Abbrechen',
			clear_input_value: 'Löschen',
			clone: 'Kopieren',
			create: 'Neu',
			delete: 'Löschen',
			edit: 'Bearbeiten',
			export: 'Exportieren',
			list: 'Zur Liste hinzufügen',
			refresh: 'Aktualisieren',
			remove_filter: 'Filter entfernen',
			remove: 'Löschen',
			save: 'Speichern',
			save_and_list: 'Speichern und zurück',
			save_and_add: 'Speichern und Neu',
			show: 'Anzeigen',
			sort: 'Nach Spalte sortieren',
			undo: 'Rückgängig',
			bulk_disable_state: 'Deaktivieren',
			bulk_enable_state: 'Aktivieren',
			change_ordering: 'Reihenfolge ändern',
			unselect: 'Auswahl aufheben',
			confirm: 'Bestätigen',
			search: 'Suchen',
		},
		locales: ConfigGeneral.locales.reduce((obj, item) => {
			return {
				...obj,
				[item.code]: item.name,
			};
		}, {}),
		boolean: {
			true: 'Ja',
			false: 'Nein',
		},
		state: {
			active: 'Aktiviert',
			inactive: 'Deaktiviert',
		},
		page: {
			create: '%{name} Erstellen',
			dashboard: 'Dashboard',
			edit: '%{name} #%{id}',
			error: 'Ein Fehler ist aufgetreten',
			list: '%{name} Liste',
			loading: 'Wird geladen',
			not_found: 'Nicht gefunden',
			show: '%{name} #%{id}',
			empty: 'Keine Einträge',
			invite: 'Erstellen Sie einen Eintrag mit der Schaltfläche unten.',
		},
		input: {
			file: {
				upload_several: 'Dateien hierher ziehen oder zum Auswählen klicken.',
				upload_single: 'Datei hierher ziehen oder zum Auswählen klicken.',
			},
			image: {
				upload_several: 'Bilder hierher ziehen oder zum Auswählen klicken.',
				upload_single: 'Bild hierher ziehen oder zum Auswählen klicken.',
			},
			references: {
				all_missing: 'Referenzdaten nicht verfügbar',
				many_missing: 'Ein Eintrag fehlt oder weitere Referenzdaten nicht verfügbar',
				single_missing: 'Referenzdaten nicht verfügbar',
			},
		},
		message: {
			about: 'Über uns',
			are_you_sure: 'Sind Sie sicher?',
			bulk_delete_content: 'Sind Sie sicher, dass Sie löschen möchten? |||| Biztosan törölsz %{smart_count} elemet?',
			bulk_delete_title: 'Element löschen |||| %{smart_count} Elemente löschen',
			delete_content: 'Sind Sie sicher, dass Sie löschen möchten?',
			delete_title: '#%{id} Löschen',
			details: 'Details',
			error: 'Clientfehler bei der Anfrage',
			invalid_form: 'Das Formular ist ungültig. Auf Fehler prüfen!',
			loading: 'Wird geladen',
			no: 'Nein',
			not_found: 'Die gesuchte Seite wurde nicht gefunden.',
			yes: 'Ja',
			bulk_disable_state: 'Möchten Sie das Element wirklich deaktivieren? |||| Möchten Sie %{smart_count} Elemente wirklich deaktivieren?',
			bulk_enable_state: 'Möchten Sie das Element wirklich aktivieren |||| Möchten Si %{smart_count}Elemente wirklich aktivieren',
		},
		navigation: {
			no_results: 'Keine Ergebnisse.',
			no_more_results: 'Keine weiteren Ergebnisse.',
			page_out_of_boundaries: '%{page}. Seite existiert nicht',
			page_out_from_end: 'Kann nicht über die letzte Seite hinaus scrolle',
			page_out_from_begin: 'Kann nicht über die erste Seite hinaus scrollen',
			page_range_info: '%{offsetBegin}-%{offsetEnd}, insgesamt %{total}',
			next: 'Nächste',
			prev: 'Vorherige',
			page_rows_per_page: 'Pro Seite:',
			skip_nav: 'Zum Inhalt springen',
		},
		auth: {
			username: 'Benutzername',
			password: 'Passwort',
			sign_in: 'Anmelden',
			sign_in_error: 'Anmeldung fehlgeschlagen.',
			logout: 'Abmelden',
			user_menu: 'Benutzer',
		},
		notification: {
			updated: 'Änderungen gespeichert |||| %{smart_count} Elemente bearbeitet',
			created: 'Element erstellt',
			deleted: 'Element gelöscht |||| %{smart_count} Elemente gelöscht',
			bad_item: 'Falsches Element',
			item_doesnt_exist: 'Element existiert nicht',
			http_error: 'Kommunikationsfehler',
			data_provider_error: 'Datenanbieterfehler',
			canceled: 'Vorgang abgebrochen',
			state_updated: 'Status aktualisiert',
			bulk_disable_state: 'Element deaktiviert |||| %{smart_count} Elemente deaktiviert',
			bulk_enable_state: 'Element aktiviert |||| %{smart_count} Elemente aktiviert',
			ordering_updated: 'Reihenfolge aktualisiert',
		},
		validation: {
			required: 'Erforderlich',
			minLength: 'Mindestens %{min} Zeichen',
			maxLength: 'Maximal %{max} Zeichen',
			minValue: 'Mindestens %{min}',
			maxValue: 'Höchstens %{max}',
			number: 'Nur Zahlen',
			email: 'Ungültiges Format',
			oneOf: 'Eines der folgenden: %{options}',
			regex: 'Muss folgendem Format entsprechen (regexp): %{pattern}',
		},
		fileManager: {
			behaviourAlert: 'Änderungen, einschließlich Datei-Uploads, werden nach dem Klicken auf die Schaltfläche "Speichern" wirksam',
			info: 'Ziehen Sie Dateien in den Bereich unten oder klicken Sie auf die Schaltfläche "Dateien hinzufügen". Sie können die Reihenfolge per Drag & Drop ändern',
			selectFiles: 'Dateien hinzufügen',
			dragOverText: 'Dateien hier ablegen',
			caption: 'Titel',
			deleteConfirm: {
				title: 'Sind Sie sicher, dass Sie die Datei löschen möchten?',
				uploadedInfo: 'Die Datei wurde bereits auf den Server hochgeladen. Wir löschen sie, sobald Sie auf „Speichern“ klicken.',
				notUploadedInfo: 'Die Datei wurde noch nicht auf den Server hochgeladen. Wir entfernen sie aus der Liste.',
				delete: 'Löschen',
				cancel: 'Abbrechen',
			}
		}
	},
};